import { render } from "./Mikomi_Game.vue?vue&type=template&id=bd4cbe66"
import script from "./Mikomi_Game.vue?vue&type=script&lang=js"
export * from "./Mikomi_Game.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__